import BaseAPI from './BaseAPI';
import ServiceApiUrlsStore from '../stores/ServiceApiUrlsStore';
import { shapeScenarioForSave, shapeScenarioForRun } from './helpers/CrossChannelAPIFormatters';

class CrossChannelAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  // Get an index of scenarios in different states (running, draft, completed)
  getScenarios() {
    return this.api
      .get('/scenarios')
      .then(data => data.body);
  }

  // Get index of runs associated with scenarios
  getRuns() {
    return this.api
      .get('/runs')
      .then(data => data.body);
  }

  // save a set of scenario params as a saved job
  createScenario(organizationId, scenario) {
    const payload = shapeScenarioForSave(organizationId, scenario);

    return this.api
      .post('/scenarios', payload)
      .then(data => data);
  }

  // destroy a scenario given the scenarioId
  destroyScenario(scenarioId) {
    return this.api
      .del(`/scenarios/${scenarioId}`)
      .then(data => data);
  }

  // Run a saved job from a savedJobID
  runSavedScenario(scenarioId) {
    const payload = shapeScenarioForRun(scenarioId);

    return this.api
      .post('/runs', payload)
      .then(data => data.body);
  }
}

class CrossChannelAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getUpxServiceUrl(), token);
    this.scenarios = new CrossChannelAPIWrapper(this);
  }

  // Need to override this because the Content-Type is different than BaseAPI
  _exec(req) {
    return req.set('Authorization', `Bearer ${this.token}`)
      .set('Content-Type', 'application/vnd.api+json')
      .then(data => data);
  }
}

export default CrossChannelAPI;
